"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectedCameraPresenterSource = ConnectedCameraPresenterSource;
exports.ConnectedScreenPresenterSource = ConnectedScreenPresenterSource;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper/broadcastSourceHelper");
var _SourceItems = require("../../constants/SourceItems");
var _propTypes = require("prop-types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ConnectedPresenterSource(_ref) {
  var _source$value;
  var source = _ref.source,
    type = _ref.type,
    isCameraOn = _ref.isCameraOn,
    style = _ref.style,
    AttendeeTileComponent = _ref.AttendeeTileComponent,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    loggedInUser = _ref.loggedInUser,
    currentUserAttendeeId = _ref.currentUserAttendeeId,
    localAttendeeVideoInput = _ref.localAttendeeVideoInput;
  var isMixerAttendee = currentUserAttendeeId === null || currentUserAttendeeId === void 0 ? void 0 : currentUserAttendeeId.includes('#mixer');
  var isLocalAttendee = (source === null || source === void 0 || (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.includes(loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser._id.toString())) && !isMixerAttendee;
  var isCameraPresenter = type === _SourceItems.CAMERA_PRESENTER;
  var photo = source === null || source === void 0 ? void 0 : source.photo;
  var id = source._id;
  var user = _objectSpread(_objectSpread({}, (0, _broadcastSourceHelper.getSourceFirstNameLastName)(source === null || source === void 0 ? void 0 : source.title)), {}, {
    photo: photo,
    id: id
  });
  var shouldMirrorVideo = isLocalAttendee && (localAttendeeVideoInput === null || localAttendeeVideoInput === void 0 ? void 0 : localAttendeeVideoInput.mirrored) && isCameraPresenter;
  return /*#__PURE__*/_react["default"].createElement(AttendeeTileComponent, {
    attendeeId: source.value,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    isCameraOn: isCameraOn,
    type: type,
    user: user,
    style: style,
    isLocalAttendee: isLocalAttendee,
    shouldMirrorVideo: shouldMirrorVideo
  });
}
ConnectedPresenterSource.propTypes = {
  source: _propTypes.object,
  type: _propTypes.string,
  isCameraOn: _propTypes.bool,
  style: _propTypes.object,
  AttendeeTileComponent: _propTypes.elementType,
  attendeeTiles: _propTypes.array,
  meetingSession: _propTypes.object,
  loggedInUser: _propTypes.object,
  currentUserAttendeeId: _propTypes.string,
  localAttendeeVideoInput: _propTypes.object
};
function ConnectedCameraPresenterSource(_ref2) {
  var source = _ref2.source,
    layer = _ref2.layer,
    AttendeeTileComponent = _ref2.AttendeeTileComponent,
    attendeeTiles = _ref2.attendeeTiles,
    meetingSession = _ref2.meetingSession,
    loggedInUser = _ref2.loggedInUser,
    currentUserAttendeeId = _ref2.currentUserAttendeeId,
    localAttendeeVideoInput = _ref2.localAttendeeVideoInput;
  return /*#__PURE__*/_react["default"].createElement(ConnectedPresenterSource, {
    source: source,
    type: _SourceItems.CAMERA_PRESENTER,
    isCameraOn: layer.isCameraOn,
    style: layer.style,
    AttendeeTileComponent: AttendeeTileComponent,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    loggedInUser: loggedInUser,
    currentUserAttendeeId: currentUserAttendeeId,
    localAttendeeVideoInput: localAttendeeVideoInput
  });
}
ConnectedCameraPresenterSource.propTypes = {
  source: _propTypes.object,
  layer: _propTypes.object,
  AttendeeTileComponent: _propTypes.elementType,
  attendeeTiles: _propTypes.array,
  meetingSession: _propTypes.object,
  loggedInUser: _propTypes.object,
  currentUserAttendeeId: _propTypes.string,
  localAttendeeVideoInput: _propTypes.object
};
function ConnectedScreenPresenterSource(_ref3) {
  var source = _ref3.source,
    AttendeeTileComponent = _ref3.AttendeeTileComponent,
    attendeeTiles = _ref3.attendeeTiles,
    meetingSession = _ref3.meetingSession,
    loggedInUser = _ref3.loggedInUser,
    currentUserAttendeeId = _ref3.currentUserAttendeeId,
    localAttendeeVideoInput = _ref3.localAttendeeVideoInput;
  return /*#__PURE__*/_react["default"].createElement(ConnectedPresenterSource, {
    source: source,
    type: _SourceItems.SCREEN_PRESENTER,
    AttendeeTileComponent: AttendeeTileComponent,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    loggedInUser: loggedInUser,
    currentUserAttendeeId: currentUserAttendeeId,
    localAttendeeVideoInput: localAttendeeVideoInput
  });
}
ConnectedScreenPresenterSource.propTypes = {
  source: _propTypes.object,
  AttendeeTileComponent: _propTypes.elementType,
  attendeeTiles: _propTypes.object,
  meetingSession: _propTypes.object,
  loggedInUser: _propTypes.object,
  currentUserAttendeeId: _propTypes.string,
  localAttendeeVideoInput: _propTypes.object
};